// File: src/components/Busy.tsx

import React, { Component } from 'react';
import '../css/components/busy.css';
import {
    CircularProgress,
    Box
} from '@mui/material';

// Visibility is tracked here, in a plain module-level variable, and pushed to every
// mounted <Busy/> instance via subscription. Previously `Busy.set()` mutated the
// "not-visible" CSS class directly on the DOM via jQuery, bypassing React entirely.
// That worked only as long as <Busy/> never re-rendered afterward — but any later
// re-render of the tree containing <Busy/> causes React to reconcile its className
// back to the literal JSX value ("busy-screen"), silently wiping out the jQuery-added
// class and leaving the spinner stuck visible forever with no further Busy.set() call
// to fix it. Driving visibility from React state instead makes it immune to reconciliation.
let isVisible = false;
const listeners = new Set<(value: boolean) => void>();

interface BusyProps {}
interface BusyState {
    visible: boolean;
}

class Busy extends Component<BusyProps, BusyState> {
    static set(value: boolean) {
        isVisible = value;
        listeners.forEach((listener) => listener(value));
    }

    state: BusyState = { visible: isVisible };

    private handleChange = (value: boolean): void => {
        this.setState({ visible: value });
    };

    componentDidMount(): void {
        listeners.add(this.handleChange);
        // Sync in case visibility changed between construction and mount.
        if (this.state.visible !== isVisible) {
            this.setState({ visible: isVisible });
        }
    }

    componentWillUnmount(): void {
        listeners.delete(this.handleChange);
    }

    render() {
        return (
            <Box className={`busy-screen${this.state.visible ? '' : ' not-visible'}`}>
                <Box className="busy-spinner-container">
                    <CircularProgress color='primary' />
                </Box>
            </Box>
        );
    }
}

export default Busy;
